import type { ReactNode } from "react";
import { useSession } from "@/features/auth/hooks/use-session";
import { advisorFirstName } from "@/features/auth/lib/advisor-name";
import { ChatGreeting } from "@/features/intelligence/home/components/ChatGreeting";
import { SimonConversationView } from "@/features/intelligence/home/components/SimonConversationView";
import { useSimonConversationNavigation } from "@/features/intelligence/home/hooks/open-conversation";
import { useHomeChat } from "@/features/intelligence/home/hooks/use-home-chat";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { DOCK_TEXT_BUTTON_CLASS } from "@/shared/ui/layout/Dock";

export function GeneralSimonChat({
  homeMode = false,
  homeSlot,
}: {
  homeMode?: boolean;
  homeSlot?: ReactNode;
}) {
  const { t } = useTranslation();
  const { data } = useSession();
  const advisorName = advisorFirstName(data?.user.name, data?.user.email);
  const { surface, submit, conversationId } = useHomeChat();
  const { closeConversation, showAllChats } = useSimonConversationNavigation();
  const empty = conversationId === null && surface.thread.nodes.length === 0 && !surface.busy;

  return (
    <SimonConversationView
      surface={surface}
      onSubmitText={submit}
      homeSlot={empty && homeSlot !== undefined ? homeSlot : undefined}
      homeGreeting={
        empty && homeSlot === undefined ? <ChatGreeting advisorName={advisorName} /> : undefined
      }
      threadTop={
        empty ? undefined : (
          <>
            <button type="button" onClick={closeConversation} className={DOCK_TEXT_BUTTON_CLASS}>
              {t("chatView.closeConversation")}
            </button>
            <button
              type="button"
              onClick={showAllChats}
              className={`ml-auto ${DOCK_TEXT_BUTTON_CLASS}`}
            >
              {t("history.all")}
            </button>
          </>
        )
      }
      homeFooterFade={homeMode}
    />
  );
}
